import React from 'react';
import OauthButton from '../../components/OauthButton/OauthButton';

const Oauths = () => (
  <div className="styles-section row" id="oauths">
    <div className='main-page-title col-12'>
      <h3>Oauth Buttons</h3>
    </div>
    <div className='home-page-content col-12 mb-4'>
      <OauthButton platform="youtube_publication" />
    </div>
    <div className='home-page-content col-12'>
      <OauthButton platform="salesforce" />
    </div>
  </div>
);

export default Oauths;
